/** @jsx isolateComponent */
import { useState } from 'react';
import { isolateComponent } from '@zapier/style-encapsulation';
import NavDot, { ACTIVE, ENABLED, DISABLED, DOT_SIZE, } from './NavDot';
const Styles = {
    root: (totalDots) => ({
        display: 'grid',
        gridGap: '10px',
        gridTemplateColumns: `repeat(${totalDots}, ${DOT_SIZE})`,
    }),
};
export const pickState = (activeDotIndex, dotIndex) => {
    if (dotIndex === activeDotIndex) {
        return ACTIVE;
    }
    if (dotIndex < activeDotIndex) {
        return ENABLED;
    }
    return DISABLED;
};
/**
 * Renders a grouping of clickable nav dots in varying states.
 */
const NavDots = ({ activeDotIndex, onDotClick, tooltips }) => {
    const totalDots = tooltips.length;
    const [focusIndex, setFocusIndex] = useState(null);
    if (activeDotIndex >= totalDots) {
        throw new Error(`NavDot ${activeDotIndex + 1} cannot be active because there are only ${totalDots} total dots.`);
    }
    return (isolateComponent("nav", { css: Styles.root(totalDots) }, Array.from(Array(totalDots), (_, i) => {
        return (isolateComponent(NavDot, { key: i, number: i + 1, onBlur: () => setFocusIndex(null), onClick: () => {
                setFocusIndex(null);
                onDotClick(i);
            }, onFocus: () => setFocusIndex(i), showTooltip: focusIndex === i, state: pickState(activeDotIndex, i), tooltip: tooltips[i] }));
    })));
};
export default NavDots;
